<template>
  <div class="mobile-article-page">
    <!-- 顶部导航栏 -->
    <div class="header">
      <span class="back-arrow" @click="goBack">
        <img
          src="@/assets/svg/Arrow_Back.svg"
          alt="back"
          style="width: 6.51vw; height: 6.51vw;"
        />
      </span>
      <h1 class="page-title">{{ pageTitle }}</h1>
      <div class="header-right"></div>
    </div>

    <!-- 文章阅读区域 -->
    <div class="article-reader">
      <bscroll-view ref="articleScroll" class="article-scroll">
        <div class="article-content-wrap">
          <!-- 文章标题 -->
          <h1 v-if="detail.title" class="article-title">
            {{ langTransfer(detail.title) }}
          </h1>

          <!-- 文章作者 -->
          <p v-if="detail.author" class="article-author">
            {{ langTransfer(detail.author) }}
          </p>

          <!-- 文章内容 -->
          <div
            v-if="detail.content"
            class="article-body"
            v-html="langTransfer(detail.content)"
          />
        </div>
      </bscroll-view>
    </div>

    <!-- 底部固定操作栏 -->
    <div class="bottom-toolbar">
      <button
        class="toolbar-btn"
        :disabled="!hasPrevChapter"
        @click="prevChapter"
      >
        <span class="btn-icon">←</span>
        <span class="btn-text">上一章</span>
      </button>
      <button class="toolbar-btn catalog-btn" @click="toggleCatalog">
        <span class="btn-icon">📑</span>
        <span class="btn-text">目录</span>
      </button>
      <button
        class="toolbar-btn"
        :disabled="!hasNextChapter"
        @click="nextChapter"
      >
        <span class="btn-text">下一章</span>
        <span class="btn-icon">→</span>
      </button>
    </div>

    <!-- 底部抽屉目录 -->
    <transition name="drawer">
      <div
        v-show="showCatalog"
        class="catalog-drawer-mask"
        @click="closeCatalog"
        @touchmove.prevent
      >
        <div class="catalog-drawer" @click.stop @touchmove.stop>
          <div class="drawer-header">
            <div class="drawer-handle" />
            <h3 class="drawer-title">{{ langTransfer('目录') }}</h3>
            <button class="drawer-close" @click="closeCatalog">×</button>
          </div>
          <div class="drawer-body" @scroll="handleCatalogScroll">
            <div class="catalog-list">
              <div
                v-for="(item, index) in menuList"
                :key="index"
                class="catalog-item"
                :class="{ active: isCurrentChapter(item) }"
                @click="selectChapter(item.unique_code)"
              >
                <span class="catalog-item-text">{{
                  langTransfer(item.title)
                }}</span>
                <span v-if="isCurrentChapter(item)" class="catalog-item-check"
                  >✓</span
                >
              </div>
            </div>

            <!-- 加载提示 -->
            <div v-if="menuList.length > 0" class="catalog-load-more">
              <!-- 加载中 -->
              <div v-if="loadingMore" class="catalog-loading">
                <div class="catalog-loading-spinner"></div>
                <span>加载中...</span>
              </div>
              <!-- 没有更多了 -->
              <div v-else-if="getAll" class="catalog-no-more">
                - 没有更多了 -
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { getKonwledgeArticle, getAuthorArticleList } from '@/api/hb';
import BscrollView from '@/components/bscrollView';

export default {
  name: 'LevelFourCatalog',
  components: {
    BscrollView,
  },
  data() {
    return {
      detail: {},
      getAll: false,
      menuList: [],
      limitId: {
        start: '',
        end: '',
      },
      showCatalog: false,
      authorName: '', // 存储作者名称（从路由传递过来）
      loadingMore: false, // 是否正在加载更多
    };
  },
  computed: {
    pageSetup() {
      return this.$store.state.pageSetup;
    },
    user_unique_code() {
      return this.$store.state.user_unique_code;
    },
    webInfo() {
      return this.$store.state.webInfo;
    },
    // 页面标题（显示作者名称）
    pageTitle() {
      return this.langTransfer(this.authorName || '文章详情');
    },
    hasPrevChapter() {
      const { menuList, $route } = this;
      if (!menuList.length) return false;
      const currentIndex = menuList.findIndex(
        (item) => item.unique_code === $route.params.id
      );
      return currentIndex > 0;
    },
    hasNextChapter() {
      const { menuList, $route, getAll } = this;
      if (!menuList.length) return false;
      const currentIndex = menuList.findIndex(
        (item) => item.unique_code === $route.params.id
      );
      // 如果是最后一章且已加载完全部，则没有下一章
      if (currentIndex === menuList.length - 1 && getAll) return false;
      // 否则有下一章（可能需要加载）
      return currentIndex < menuList.length - 1 || !getAll;
    },
  },
  watch: {
    // 监听 webInfo 的变化,确保 service_code 存在后再加载数据
    'webInfo.service_code': {
      handler(newVal) {
        if (newVal && !this.detail.title) {
          // 使用 nextTick 确保在下一个 DOM 更新周期执行
          this.$nextTick(() => {
            this.getDetail();
          });
        }
      },
      immediate: true, // 立即执行一次,如果 service_code 已存在
    },
  },
  mounted() {
    // 从路由 params 参数获取作者名称
    if (this.$route.params.authorName) {
      this.authorName = this.$route.params.authorName;
    }
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    // 判断是否为当前章节
    isCurrentChapter(item) {
      return this.$route.params.id === item.unique_code;
    },
    // 切换目录显示状态
    toggleCatalog() {
      this.showCatalog = !this.showCatalog;
    },
    // 关闭目录
    closeCatalog() {
      this.showCatalog = false;
    },
    // 处理目录滚动（用于上拉加载更多）
    handleCatalogScroll(e) {
      if (this.getAll) {
        return;
      }
      const target = e.target;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;

      // 接近底部时加载更多
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.loadMoreCatalog();
      }
    },
    // 加载更多目录
    loadMoreCatalog() {
      if (this.getAll || this.loadingMore) {
        return;
      }
      this.loadingMore = true;
      const newPage = Math.ceil(this.menuList.length / 15) + 1;
      this.getCatelog(newPage).finally(() => {
        this.loadingMore = false;
      });
    },
    // 选择章节
    selectChapter(uniqueCode) {
      this.closeCatalog();
      this.subCateClick(uniqueCode);
    },
    // 上一章
    prevChapter() {
      this.chapter(true);
    },
    // 下一章
    nextChapter() {
      this.chapter(false);
    },
    chapter(isPrev) {
      const { menuList, getAll } = this;
      const { id } = this.$route.params;
      let newItem;
      const currentIndex = menuList.findIndex((e) => {
        return e.unique_code === id;
      });
      if (currentIndex === menuList.length - 2 && !getAll) {
        this.loadMore();
      }
      if (isPrev) {
        newItem = menuList[currentIndex - 1];
      } else {
        newItem = menuList[currentIndex + 1];
      }
      if (!newItem) {
        return;
      }
      const { unique_code } = newItem;
      this.subCateClick(unique_code);
    },
    subCateClick(id) {
      /*  this.$router.push({
                    params: {
                        id
                    }
                }) */
      // 如果当前的路由就是目标路由，则不进行跳转
      if (this.$route.params.id === id) return;
      this.$router.replace({
        params: { id },
      });
    },
    async getDetail(id) {
      try {
        const { webInfo, $route, user_unique_code } = this;
        const data = await getKonwledgeArticle({
          service_code: webInfo.service_code,
          type: 6,
          id: id || $route.params.id,
          user_unique_code,
        });
        this.detail = data;
        if (!this.menuList[0]) {
          this.getCatelog();
        }
      } catch (err) {
        console.log(err);
      }
    },
    loadMore(bscrollObj) {
      // 保留此方法以兼容可能的其他调用
      if (this.getAll) {
        return;
      }
      const newPage = Math.ceil(this.menuList.length / 15) + 1;
      this.getCatelog(newPage, bscrollObj);
    },
    async getCatelog(page = 1, bscrollObj) {
      try {
        const { webInfo, detail } = this;
        const data = await getAuthorArticleList({
          service_code: webInfo.service_code,
          author_unique_code: detail.author_unique_code,
          page,
          pageSize: 15,
        });
        if (data.length < 15) {
          this.getAll = true;
        }
        if (page !== 1) {
          this.menuList = this.menuList.concat(data);
          this.setLimitId();
          if (bscrollObj) {
            bscrollObj.finishPullUp();
          }
          return;
        }
        this.menuList = data;
        this.setLimitId();
      } catch (err) {
        if (err.code === '-1') {
          this.getAll = true;
        }
        console.log(err);
      }
    },
    setLimitId() {
      const { menuList, getAll } = this;
      this.limitId = {
        start: menuList[0].unique_code,
        end: getAll ? menuList[menuList.length - 1].unique_code : -1,
      };
      if (getAll) {
        return;
      }

      const { id } = this.$route.params;
      const hasCurrent =
        menuList.findIndex((e) => {
          return e.unique_code === id;
        }) !== -1;
      if (!hasCurrent) {
        this.loadMore();
      }
    },
  },
  async beforeRouteUpdate(to, from, next) {
    const { id } = to.params;
    next();
    await this.getDetail(id);
    // 切换章节时重置滚动位置
    this.$nextTick(() => {
      const articleScroll = this.$refs.articleScroll;
      if (articleScroll && articleScroll.$refs.vs) {
        articleScroll.$refs.vs.scrollTo({ y: 0 }, 0); // 立即滚动到顶部
        articleScroll.refresh();
      }
    });
  },
  beforeRouteEnter: (to, from, next) => {
    next((vm) => {
      const { service_code } = vm.webInfo;
      if (service_code) {
        vm.getDetail();
      }
    });
  },
};
</script>

<style scoped lang="less">
/* 移动端文章页面容器 */
.mobile-article-page {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 文章阅读区域 */
.article-reader {
  flex: 1;
  width: 100%;
  overflow: hidden;
  padding-bottom: 56px; /* 底部操作栏高度 */
}

.article-scroll {
  width: 100%;
  height: 100%;
}

/* 文章内容容器 */
.article-content-wrap {
  width: 100%;
  min-height: 100%;
  padding: 20px 16px 40px;
  box-sizing: border-box;
}

/* 文章标题 */
.article-title {
  font-size: 24px;
  font-family: AlibabaPuHuiTiB;
  color: #303133;
  line-height: 1.4;
  margin: 0 0 12px;
  font-weight: 600;
  word-break: break-word;
}

/* 文章作者 */
.article-author {
  font-size: 13px;
  font-family: AlibabaPuHuiTiR;
  color: #909399;
  line-height: 20px;
  margin: 0 0 24px;
}

/* 文章正文 */
.article-body {
  width: 100%;
  font-size: 16px;
  font-family: AlibabaPuHuiTiR;
  color: #303133;
  line-height: 1.8;
  word-break: break-word;
}

/* 底部固定操作栏 */
.bottom-toolbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: #ffffff;
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  z-index: 100;
  /* 安全区域适配 */
  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);

  .toolbar-btn {
    flex: 1;
    height: 100%;
    background: none;
    border: none;
    font-size: 14px;
    color: #303133;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    cursor: pointer;
    user-select: none;
    transition: all 0.2s;
    position: relative;

    &:not(:last-child)::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 20px;
      background: #e4e7ed;
    }

    .btn-icon {
      font-size: 16px;
    }

    .btn-text {
      font-size: 14px;
      font-family: AlibabaPuHuiTiR;
    }

    &.catalog-btn {
      color: #409eff;
      font-weight: 500;
    }

    &:disabled {
      color: #c0c4cc;
      cursor: not-allowed;
      opacity: 0.5;
    }

    &:not(:disabled):active {
      background: #f5f7fa;
    }
  }
}

/* 底部抽屉遮罩 */
.catalog-drawer-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 200;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  touch-action: none;
}

/* 底部抽屉 */
.catalog-drawer {
  width: 100%;
  max-height: 70vh;
  background: #ffffff;
  border-radius: 16px 16px 0 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  touch-action: pan-y;
}

/* 抽屉头部 */
.drawer-header {
  position: relative;
  padding: 12px 20px;
  border-bottom: 1px solid #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;

  .drawer-handle {
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 4px;
    background: #e4e7ed;
    border-radius: 2px;
  }

  .drawer-title {
    margin: 8px 0 0;
    font-size: 16px;
    font-family: AlibabaPuHuiTiB;
    color: #303133;
    font-weight: 600;
  }

  .drawer-close {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    background: none;
    border: none;
    font-size: 24px;
    color: #909399;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s;

    &:active {
      background: #f5f7fa;
    }
  }
}

/* 抽屉主体 */
.drawer-body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

/* 目录列表 */
.catalog-list {
  padding: 8px 20px 20px;
}

.catalog-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  border-bottom: 1px solid #f0f2f5;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;

  &:last-child {
    border-bottom: none;
  }

  .catalog-item-text {
    flex: 1;
    font-size: 15px;
    font-family: AlibabaPuHuiTiR;
    color: #606266;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .catalog-item-check {
    margin-left: 12px;
    font-size: 16px;
    color: #409eff;
    flex-shrink: 0;
  }

  &.active {
    .catalog-item-text {
      color: #303133;
      font-weight: 600;
      font-family: AlibabaPuHuiTiM;
    }
  }

  &:active {
    background: #f5f7fa;
  }
}

/* 目录加载提示 */
.catalog-load-more {
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 加载中 */
.catalog-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #909399;
  font-size: 14px;
  font-family: AlibabaPuHuiTiR;
}

.catalog-loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #409eff;
  border-radius: 50%;
  animation: catalog-spin 1s linear infinite;
}

@keyframes catalog-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 没有更多了 */
.catalog-no-more {
  font-size: 14px;
  font-family: AlibabaPuHuiTiR;
  color: #aaa9a9;
  user-select: none;
}

/* 抽屉动画 */
.drawer-enter-active,
.drawer-leave-active {
  transition: all 0.3s ease;

  .catalog-drawer {
    transition: transform 0.3s ease;
  }
}

.drawer-enter-from,
.drawer-leave-to {
  opacity: 0;

  .catalog-drawer {
    transform: translateY(100%);
  }
}

.drawer-enter-to,
.drawer-leave-from {
  opacity: 1;

  .catalog-drawer {
    transform: translateY(0);
  }
}
</style>

<!-- 文章内容样式（非 scoped） -->
<style lang="less">
/* 文章段落 */
.article-body p {
  margin: 0 0 1em;
  font-size: 16px;
  line-height: 1.8;
  color: #303133;
  word-break: break-word;
}

/* 文章图片 */
.article-body img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 16px auto;
  border-radius: 4px;
}

.article-body figure {
  margin: 16px 0;

  img {
    width: 100%;
  }
}

/* 文章标题 */
.article-body h1,
.article-body h2,
.article-body h3,
.article-body h4,
.article-body h5,
.article-body h6 {
  margin: 1.2em 0 0.6em;
  font-weight: 600;
  line-height: 1.4;
  color: #303133;
}

.article-body h1 {
  font-size: 22px;
}

.article-body h2 {
  font-size: 20px;
}

.article-body h3 {
  font-size: 18px;
}

.article-body h4,
.article-body h5,
.article-body h6 {
  font-size: 16px;
}

/* 列表 */
.article-body ul,
.article-body ol {
  margin: 1em 0;
  padding-left: 1.5em;
}

.article-body li {
  margin: 0.5em 0;
  line-height: 1.8;
}

/* 引用 */
.article-body blockquote {
  margin: 1em 0;
  padding: 12px 16px;
  background: #f5f7fa;
  border-left: 4px solid #409eff;
  color: #606266;
}

/* 代码块 */
.article-body pre {
  margin: 1em 0;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 4px;
  overflow-x: auto;
}

.article-body code {
  font-family: 'Courier New', Courier, monospace;
  font-size: 14px;
}

/* 链接 */
.article-body a {
  color: #409eff;
  text-decoration: none;

  &:active {
    opacity: 0.7;
  }
}

/* 表格 */
.article-body table {
  width: 100%;
  margin: 1em 0;
  border-collapse: collapse;
  font-size: 14px;
}

.article-body th,
.article-body td {
  padding: 8px 12px;
  border: 1px solid #e4e7ed;
  text-align: left;
}

.article-body th {
  background: #f5f7fa;
  font-weight: 600;
}
/* Header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3.72vw 4.65vw; /* 16px 20px */
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 100;
}

.back-arrow {
  font-size: 6.51vw; /* ~28px */
  cursor: pointer;
  color: #333;
  display: flex;
  align-items: center;
  line-height: 1;
}

.back-arrow:hover {
  color: #007bff; /* Optional hover effect */
}

.page-title {
  font-size: 4.65vw; /* ~20px */
  font-weight: bold;
  color: #333;
  margin: 0;
}

.header-right {
  width: 6.51vw; /* To balance the layout if no right element exists */
}
</style>
